import React from "react";
import styled, { withTheme } from "styled-components/native";
import { injectIntl } from "react-intl";
import { material } from "react-native-typography";
import {
  Container,
  ListInspectContext,
  ListToolbar,
  QueryInfiniteList
} from "cci-component";
import { localize } from "cci-utility";
//TODO autoUpdate prop needs to really be a separate component
import Updater from "./Updater";
import { ListTitle } from "../layout/Titles";

/**
 * List page that does not allow adding a new record.
 *
 * Props:
 * - searchPlaceholder: Placeholder for the search field along the top. Defaults to "Search".
 * - autoupdate: If you want an autoupdate login of ten minutes each.
 * - listTitle: intl object to display as title
 */
const ImmutableList = ({
  theme,
  intl,
  listTitle,
  autoupdate,
  toolbar = true,
  enableFilter,
  showFilterPage,
  ...restProps
}) => (
  <ListInspectContext.Consumer>
    {({ setQuery, setVariables }) => (
      <QueryInfiniteList
        // Filter toolbar along the top
        fixedHeader={(refetch, filter, currentFilter) => (
          <Container
            style={{
              marginLeft: theme.list.horizontalMargins,
              marginRight: theme.list.horizontalMargins,
              marginTop: theme.pageContentMarginTop
            }}
          >
            <Container
              style={{
                marginTop: theme.list.titleMarginTop,
                marginBottom: theme.list.titleMarginBottom
              }}
            >
              <ListTitle>{localize(intl, listTitle)}</ListTitle>
              {autoupdate && <Updater refetch={refetch} />}
            </Container>

            {toolbar && (
              <ListToolbar
                refresh={refetch}
                filter={filter}
                currentFilter={currentFilter}
                placeholder={restProps.searchPlaceholder}
                enableFilter={enableFilter}
                showFilterPage={showFilterPage}
              />
            )}
          </Container>
        )}
        horizontalMargins={theme.list.horizontalMargins}
        onQueryUpdate={setQuery}
        onVariablesUpdate={setVariables}
        {...restProps}
      />
    )}
  </ListInspectContext.Consumer>
);

export default injectIntl(withTheme(ImmutableList));
